import FormFeedback from "./FormFeedback";
import { IconButton } from "./TooltipControls";
import * as React from "react";
import { Checkbox, Col, ControlLabel, FormControl, FormGroup, InputGroup, } from "react-bootstrap";
import { ComponentEx } from "./ComponentEx";
import FormInput from "./FormInput";
export class FormTextItem extends React.Component {
    render() {
        const { controlId, label, maxLength, placeholder, readOnly, style, value } = this.props;
        const validation = value !== undefined ? this.validationState() : undefined;
        const validationState = validation === undefined
            ? undefined
            : validation === null
                ? "success"
                : "error";
        return (React.createElement(FormGroup, { controlId: controlId, validationState: validationState, style: style },
            React.createElement(Col, { componentClass: ControlLabel, sm: 3 }, label),
            React.createElement(Col, { sm: 9 },
                React.createElement(FormInput, { type: "text", placeholder: placeholder, value: value || "", onChange: this.onChangeValue, readOnly: readOnly, maxLength: maxLength }),
                validation ? React.createElement(ControlLabel, null, validation) : null),
            React.createElement(FormFeedback, null)));
    }
    validationState() {
        const { validator, value } = this.props;
        if (validator === undefined) {
            return undefined;
        }
        return validator(value);
    }
    onChangeValue = (value) => {
        const { stateKey, onChangeValue } = this.props;
        onChangeValue(stateKey, value);
    };
}
export class FormCheckboxItem extends React.Component {
    render() {
        const { label, style, value } = this.props;
        return (React.createElement(Checkbox, { value: value, onChange: this.onChangeValue, style: style }, label));
    }
    onChangeValue = (evt) => {
        const { stateKey, onChangeValue } = this.props;
        if (onChangeValue !== undefined) {
            onChangeValue(stateKey, evt.currentTarget.value);
        }
    };
}
export class FormPathItem extends ComponentEx {
    render() {
        const { t, controlId, label, placeholder, readOnly, style, value } = this.props;
        const validation = value !== undefined ? this.validationState() : undefined;
        const validationState = validation === undefined
            ? undefined
            : validation === null
                ? "success"
                : "error";
        return (React.createElement(FormGroup, { controlId: controlId, validationState: validationState, style: style },
            React.createElement(Col, { componentClass: ControlLabel, sm: 3 }, label),
            React.createElement(Col, { sm: 9 },
                React.createElement(InputGroup, null,
                    React.createElement(FormControl, { type: "text", value: value, placeholder: placeholder, readOnly: readOnly, onChange: this.handleTypePath }),
                    readOnly ? null : (React.createElement(InputGroup.Button, { className: "inset-btn" },
                        React.createElement(IconButton, { id: "change-tool-path", tooltip: t("Change"), onClick: this.handleChangePath, icon: "browse" })))),
                validation ? React.createElement(ControlLabel, null, validation) : null)));
    }
    validationState() {
        const { validator, value } = this.props;
        if (validator === undefined) {
            return undefined;
        }
        return validator(value);
    }
    handleTypePath = (evt) => {
        const { onChangeValue, stateKey } = this.props;
        onChangeValue(stateKey, evt.target.value);
    };
    handleChangePath = () => {
        const { directory, extensions, onChangeValue, stateKey, value } = this.props;
        const func = directory
            ? this.context.api.selectDir
            : this.context.api.selectFile;
        func({
            defaultPath: value,
            filters: extensions !== undefined ? [{ name: "Files", extensions }] : [],
        }).then((result) => {
            if (result !== undefined) {
                onChangeValue(stateKey, result);
            }
        });
    };
}
